import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { detachTyreReplacementsFromIntervention } from "modules/AppointmentDetails/utils";
import { ApiInstance } from "utils/Api";

export const useDeleteInterventionMutation = () =>
  useTypedMutation({
    mutationFn: async (id: number) => {
      await ApiInstance.post("/interventions/delete", { id });
    },
    onSuccess: interventionId => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(({ id }) => id === interventionId);
      if (interventionIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        car: appointment.car ? { ...appointment.car, tyres: detachTyreReplacementsFromIntervention(interventionId, appointment.car.tyres) } : appointment.car,
        interventions: appointment.interventions.toSpliced(interventionIdx, 1)
      });
    }
  });
